export const routes = {
    "/preschoolplayhouse":{component:"components/landingPages/PreschoolPlayhouse"}
};
